export default "__VITE_ASSET__CnPDbAZX__"